// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.ReauthenticatePaymentMethodWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { ReauthenticatePaymentMethodWebApiHandler_reauthenticateRenterPaymentMethod } from '@zg-rentals/ts-rent-payment-client';

import type {
  ReauthenticatePaymentMethodWebApiRequestDto,
  ReauthenticatePaymentMethodWebApiResponseDto,
} from '@zg-rentals/ts-rent-payment-client';

export interface ReauthenticatePaymentMethodWebApiHandler_reauthenticateRenterPaymentMethod_Args {
  postData: ReauthenticatePaymentMethodWebApiRequestDto;
}

export type ReauthenticatePaymentMethodWebApiHandler_reauthenticateRenterPaymentMethod_Options = UseMutationOptions<
  ReauthenticatePaymentMethodWebApiResponseDto,
  unknown,
  ReauthenticatePaymentMethodWebApiHandler_reauthenticateRenterPaymentMethod_Args
>;

/**
 * Reauthenticate Renter's Payment Method
 */
export const useReauthenticatePaymentMethodWebApiHandler_reauthenticateRenterPaymentMethod = ({
  httpClient,
  ...options
}: Omit<ReauthenticatePaymentMethodWebApiHandler_reauthenticateRenterPaymentMethod_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: ReauthenticatePaymentMethodWebApiHandler_reauthenticateRenterPaymentMethod_Args) =>
      ReauthenticatePaymentMethodWebApiHandler_reauthenticateRenterPaymentMethod(args.postData, httpClient),
  });
};
